export default __webpack_public_path__ + "static/media/03.09d25bc2.png";